import { Controller } from "stimulus"

import "leaflet/dist/leaflet.css"

export default class extends Controller {
  static values = {
    markersData: Array
  }

  connect () {
    import("leaflet").then(() =>
      Promise.all([
        import("mapbox-gl-leaflet")
      ]).then(() => {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.initializeLeaflet() // Initialisation de la carte
              this.observer.disconnect()
            }
          })
        }, { threshold: 0.05 }) // Déclenche lorsque 5% de l'élément est visible
        this.observer.observe(this.element)
      })
    )
  }

  disconnect () {
    this.map.remove()
    super.disconnect()
    document.removeEventListener("highlight-agency-on-map", this.boundOnHighlightAgency)
  }

  initializeLeaflet () {
    if (this.map) return // Empêche le chargement multiple

    this.map = L.map(this.element)
    this.setMapCenter() // On centre sur la France par défaut avant de charger les markers
    this.loadMarkers()
    document.addEventListener("highlight-agency-on-map", this.onHighlightAgency.bind(this))
    L.mapboxGL({
      style: 'https://api.maptiler.com/maps/73b3fa62-5f0d-4c07-81ac-15d1cdf7576e/style.json?key=bxcrVqtU886vRzzW6eJw',
      accessToken: 'pk.eyJ1Ijoic2hiY29tcGFyZXQiLCJhIjoiY2tuZzFma2xlMWR2MTJvbzd3OXUyZTJtYyJ9.gxgdOHGfnUEzMvoM4aoU6g'
    }).addTo(this.map)
  }

  // Récupération des markers et clusters
  get markers () {
    const markers = []
    this.map.eachLayer(layer => {
      if (typeof layer.getAllChildMarkers === "function") { // this layer is a cluster
        markers.push(...layer.getAllChildMarkers())
      } else if (layer instanceof L.Marker) { // this layer is a marker
        markers.push(layer)
      }
    })
    return [...new Set(markers)].sort() // sort and remove duplicates
  }

  loadMarkers () {
    this.markersDataValue.forEach(marker => {
      this.createMarkerLayer(marker).addTo(this.map)
    })
  }

  createMarkerLayer ({ latitude, longitude, popupContentHtml, ...customOptions }) {
    const marker = L.marker({ lat: latitude, lng: longitude }, { icon: this.createMarkerIcon(), ...customOptions })
    const defaultPopupOptions = { minWidth: 50, maxWidth: 300, autoPanPadding: [10, 10] }
    const popup = L.popup(defaultPopupOptions).setContent(popupContentHtml)
    marker.bindPopup(popup, { offset: L.point(0, -15) })
    return marker
  }

  createMarkerIcon (highlighted = false) {
    const mainColor = highlighted ? "text-primary-700" : "text-primary-300"
    const htmlIcon = `<i class="fas fa-map-marker-alt ${mainColor}" style="font-size: 35px"></i>`
    return L.divIcon({
      className: 'flex justify-center',
      html: htmlIcon,
      iconAnchor: [6, 30]
    })
  }

  setMapCenter () {
    const latLngs = this.markersDataValue.map(({ latitude, longitude }) => [latitude, longitude])

    if (latLngs.length > 1) { // multiple pins
      this.map.fitBounds(latLngs, { padding: [50, 50] })
    } else if (latLngs.length === 1) { // exactly 1 pin
      this.map.setView(latLngs[0], this.vagueValue ? 14 : 16)
    } else { // france
      this.map.setView([47, 2], 6)
    }
  }

  onHighlightAgency (event) {
    const marker = this.findAgencyMarker(event.detail.agencyId)
    console.log(marker)
    if (!marker) {
      console.warn("Leaflet marker not found for:", event.detail)
      return
    }

    this.highlightMarker(marker)
  }

  findAgencyMarker (agencyId) {
    console.log(agencyId)
    console.log(this.markers)
    return this.markers.find(marker =>
      marker.options.id == agencyId // eslint-disable-line eqeqeq
    )
  }

  highlightMarker (marker) {
    if (this._highlightedMarker === marker) return
    this._highlightedMarker = marker

    this.resetAllMarkers()

    marker.setIcon(this.createMarkerIcon(true))
    marker.setZIndexOffset(9999)
    setTimeout(() => marker.openPopup(), 0) // `setTimeout` prevents a race condition
  }

  resetAllMarkers () {
    this.markers.forEach(marker => {
      marker.setIcon(this.createMarkerIcon())
      marker.setZIndexOffset(0)
    })
  }

  // closeAllPopups () {
  //   this.markers.forEach(marker => marker.closePopup())
  // }
}
